module.exports = __webpack_public_path__ + "info2logo-f203a7cd510e1008fdaa5cec46805be2.png";